(function () {

  var calculatorBox = {

    init: function (calculator) {

      this.slider(calculator);

      this.tabs(calculator);

      this.zip(calculator);

      this.submit(calculator);

      this.customValidity(calculator);
    },

    /**
     * Checks whether an local environment is used.
     * @returns true if the code is run in an local environment.
     */
    isLocal: function() {
      return window.location.hostname.includes('localhost') || window.location.hostname.includes('192.168.56.1');
    },

    tabs: function (calculator) {
      var tabs = calculator.querySelectorAll('.calc-tabs a, button[data-segment]');

      [].forEach.call(tabs, function (tab, index)  {

        if(index == 0) {
          var active = calculator.querySelector('.calc-tabs a.active')
          if(active) {
            active.classList.remove('active');
          }
          tab.classList.add('active');
          var segment = tab.getAttribute('data-segment');

          var contentActive = calculator.querySelector('.calc-content.active');
          if(contentActive) {
            contentActive.classList.remove('active');
          }

          let content = calculator.querySelector('.calc-content.' + segment);
          if (content) {
             content.classList.add('active');
          }
        }

        tab.addEventListener('click', function (event) {
          event.preventDefault();
          calculator.querySelector('.calc-tabs a.active').classList.remove('active');


          /**
           * Enable buttons in the calc-content to be used for navigation between tabs
           * Define the [data-target-tab] attribute with the corresponding [data-segment] that should be activated.
           */
          var targetTab = tab;
          if (tab instanceof HTMLButtonElement && tab.hasAttribute('data-target-tab')) {
            targetTab = calculator.querySelector('.calc-tabs [data-segment=' + tab.dataset.targetTab + "]");
            if(!targetTab) throw new Error('Make sure there is a calc-tab corresponding to the data attribute.');
          }
          targetTab.classList.add('active');

          var segment = tab.getAttribute('data-segment');

          calculator.querySelector('.calc-content.active').classList.remove('active');
          calculator.querySelector('.calc-content.' + segment).classList.add('active');
        })
      });
      var evalHeights = function () {
        var calcContents = calculator.querySelectorAll('div[data-segment]'),
            blacklist = ['emobility', 'emobility-combi-tariff', 'emobility-single-tariff'],
            maxHeight = 0;

        [].forEach.call(calcContents, function(calcContent) {
          // Exclude listed elements from the height calculation
          if(!blacklist.indexOf(calcContent.dataset.segment)) {
            maxHeight = Math.max(maxHeight, calcContent.getBoundingClientRect().height);
          }
        });

        [].forEach.call(calcContents, function (calcContent) {
          calcContent.style.boxSizing = 'border-box';
          calcContent.style.minHeight = (maxHeight) + 'px';
        });

      }
      // window.addEventListener('DOMContentLoaded', evalHeights);
      // window.addEventListener('resize', evalHeights);
    },

    slider: function (calculator) {

      var sliders = calculator.querySelectorAll('.calc-slider');

      [].forEach.call(sliders, function (slider) {
        var input;
        if (calculator.classList.contains('old-calculator')) {
          input = calculator.querySelector('input[class=' + (slider.querySelector('label').getAttribute('for'))+ ']');
        } else {
          input = calculator.querySelector('.' + slider.getAttribute('data-target-class'));
        }

        var handle = slider.querySelector('.handle'),
            sliderWidth,
            sliderValue = parseInt(slider.getAttribute('data-value')),
            sliderMaxValue = parseInt(slider.getAttribute('data-max')),
            sliderMinValue = parseInt(slider.getAttribute('data-min')),
            startSliderValue,
            handleLeft = 0,
            pattern = slider.getAttribute('data-pattern'),
            steps = slider.getAttribute('data-steps') ? parseInt(slider.getAttribute('data-steps')) : 100,
            inputFactor = (input && input.getAttribute('data-factor')) ? parseFloat(input.getAttribute('data-factor')) : 1,
            inputMultiplicator = (input && input.getAttribute('data-factor-multiplicator')) ? parseFloat(input.getAttribute('data-factor-multiplicator')) : 0,
            inputSteps = (input && input.getAttribute('data-steps')) ? input.getAttribute('data-steps').split(',') : 0;

        // Enable setting slider value via click on range bar
        slider.addEventListener('click', function(event) {
          event.preventDefault();

          var left = event.clientX - slider.getBoundingClientRect().left,
              value =  sliderMinValue + Math.round(left / slider.offsetWidth * (sliderMaxValue - sliderMinValue));

          if(value > sliderMinValue && value <= sliderMaxValue) {
            sliderValue = Math.round(value/steps) * steps;
              if (calculator.classList.contains('old-calculator')) {
                  setInputValue_old(sliderValue);
                  setSliderValue_old(sliderValue);
                  setLabelValue_old(sliderValue);
              } else {
                  setInputValue(sliderValue);
                  setSliderValue(sliderValue);
                  setLabelValue(sliderValue);
              }
          }
        });

        if (input) {
          // input focus and clear
          input.addEventListener('focus', function () {
            input.setAttribute('placeholder', '');
            input.value = '';
          })

          // input blur and if cleared set the slider value
          input.addEventListener('blur', function () {
            if (!input.value) {
              if (calculator.classList.contains('old-calculator')) {
                setInputValue_old(sliderValue);
              } else {
                setInputValue(sliderValue);
              }
            }
          })
          input.addEventListener('change', function () {
            var value = 0;
            if(!isNaN(parseInt(this.value))) {
              value = Math.round(parseInt(this.value) / inputFactor);
              if(value > sliderMinValue && value <= sliderMaxValue) {
                sliderValue = value;
                  if (calculator.classList.contains('old-calculator')) {
                      setInputValue_old(sliderValue);
                      setSliderValue_old(sliderValue);
                      // setLabelValue_old(sliderValue);
                  } else {
                      setSliderValue(sliderValue);
                      setLabelValue(sliderValue);
                      //setInputValue(sliderValue);
                  }
              }
            } else {
              sliderValue = value;
                if (calculator.classList.contains('old-calculator')) {
                    setSliderValue_old(sliderValue);
                    setLabelValue_old(sliderValue);
                } else {
                    setSliderValue(sliderValue);
                    setLabelValue(sliderValue);
                }
            }
          });
          input.addEventListener('blur', function () {
            if(!isNaN(parseInt(this.value))) {

              var value = Math.round(parseInt(this.value)/inputFactor);
              if(inputSteps) {
                if (value < inputSteps[0]) {
                  this.value = inputSteps[0] * inputFactor;
                  value = inputSteps[0];
                }

                var min = 10000000, tempValue, currentValue = parseInt(this.value);
                inputSteps.forEach(function (step, index) {
                  var comp = Math.abs(currentValue - parseInt(step));
                  if(Math.min(comp, min) < min) {
                    min = Math.min(comp, min);
                    tempValue = index + 1;
                  }
                });

                sliderValue = tempValue;
                  if (calculator.classList.contains('old-calculator')) {
                      setLabelValue_old(sliderValue);
                      setSliderValue_old(sliderValue);
                  } else {
                      setSliderValue(sliderValue);
                      setLabelValue(sliderValue);
                  }

                var inputPattern = this.getAttribute('data-pattern') ? input.getAttribute('data-pattern') : pattern;
                this.value = inputPattern.replace('_', parseInt(this.value));
              }
              else if (value <= sliderMinValue) {
                sliderValue = sliderMinValue;
                this.value = sliderMinValue * inputFactor;
                  if (calculator.classList.contains('old-calculator')) {
                      setSliderValue_old(sliderValue);
                      setLabelValue_old(Math.round(sliderMinValue));
                  } else {
                      setSliderValue(sliderValue);
                      setLabelValue(Math.round(sliderMinValue));
                  }

                //setInputValue(sliderValue);
                var inputPattern = this.getAttribute('data-pattern') ? input.getAttribute('data-pattern') : pattern;
                this.value = inputPattern.replace('_', parseInt(this.value));
              }
              else if (value > sliderMaxValue) {
                sliderValue = sliderMaxValue;
                  if (calculator.classList.contains('old-calculator')) {
                      setSliderValue_old(sliderValue);
                      setLabelValue_old(Math.round(parseInt(this.value)/inputFactor));
                  } else {
                      setSliderValue(sliderValue);
                      setLabelValue(Math.round(parseInt(this.value)/inputFactor));
                  }

                //setInputValue(sliderValue);
                var inputPattern = this.getAttribute('data-pattern') ? input.getAttribute('data-pattern') : pattern;
                this.value = inputPattern.replace('_', parseInt(this.value));
              }
              else {
                sliderValue = value;
                  if (calculator.classList.contains('old-calculator')) {
                      setSliderValue_old(sliderValue);
                      setLabelValue_old(sliderValue);
                  } else {
                      setSliderValue(sliderValue);
                      setLabelValue(sliderValue);
                  }

                //setInputValue(sliderValue);
                var inputPattern = this.getAttribute('data-pattern') ? input.getAttribute('data-pattern') : pattern;
                this.value = inputPattern.replace('_', parseInt(this.value));
              }
            } else {
              console.log('xx');
            }
          })
        }

        function setInputValue(value, specificForm = '') {
          if (input) {
            var inputPattern = input.getAttribute('data-pattern') ? input.getAttribute('data-pattern') : pattern,
                inputRound = input.getAttribute('data-round') ? input.getAttribute('data-round') : 1,
                tempValue = value * inputFactor;

            if (inputMultiplicator) {
              tempValue = inputFactor + (value - 1) * inputMultiplicator * inputFactor;
            }

            if (inputSteps) {
              tempValue = inputSteps[tempValue - 1] ? inputSteps[tempValue - 1] : tempValue;
            }

            var newValue = inputPattern.replace('_', Math.round(tempValue / inputRound) * inputRound);

            var segment = calculator.getAttribute('data-segment');
            var formsBySegments = document.querySelectorAll('.calc-content.' + segment + ' .' + (slider.getAttribute('data-target-class')));
            [].forEach.call(formsBySegments, function (temp) {
              temp.value = newValue;
            });
          }
        }

          function setSliderValue_old(value) {
              var percentLeft = getPercentage(value);
              if(percentLeft < 0)
                  percentLeft = getPercentage(1);
              handle.style.left = percentLeft + '%';
              slider.querySelector('.range .status').style.width = percentLeft + '%';
              handleLeft = percentLeft;

          }

          function setInputValue_old(value) {
              var inputPattern = input.getAttribute('data-pattern') ? input.getAttribute('data-pattern') : pattern,
                  inputRound = input.getAttribute('data-round') ? input.getAttribute('data-round') : 1,
                  tempValue = value * inputFactor;

              if(inputMultiplicator) {
                  tempValue = inputFactor + (value - 1) * inputMultiplicator * inputFactor;
              }

              if(inputSteps) {
                  tempValue = inputSteps[tempValue -1] ? inputSteps[tempValue -1] : tempValue;
              }

              input.value = inputPattern.replace('_', Math.round(tempValue / inputRound) * inputRound);
          }

          function setLabelValue_old(value) {
              var label = slider.querySelector('label');
              if(value != null) {
                  label.innerText = pattern.replace('_', value);
              }
          }

          function setLabelValue(value) {
          var segment = calculator.getAttribute('data-segment');

          let sliderCategory = '';
          if (slider.hasAttribute('data-wrap-class')) {
            sliderCategory = ' .' + (slider.getAttribute('data-wrap-class'));
          }
          let formsBySegments = document.querySelectorAll('.calc-content.' + segment + sliderCategory );

          [].forEach.call(formsBySegments, function(temp){
            var label = temp.querySelector('.slider-label');
            if(value != null && label) {
              label.innerText = pattern.replace('_', value);
            }
          });
        }

        function setSliderValue(value) {
          var percentLeft = getPercentage(value);
          if(percentLeft < 0)
            percentLeft = getPercentage(1);
          // handle.style.left = percentLeft + '%';
          // slider.querySelector('.range .status').style.width = percentLeft + '%';
          var segment = calculator.getAttribute('data-segment');
          let sliderCategory = '';
          if (slider.hasAttribute('data-wrap-class')) {
            sliderCategory = ' .' + (slider.getAttribute('data-wrap-class'));
          }
          let formsBySegments = document.querySelectorAll('.calc-content.' + segment + sliderCategory );

          [].forEach.call(formsBySegments, function(temp){
            var slider2 = temp.querySelector('.range .status');
            if (slider2) {
              temp.querySelector('.range .status').style.width = percentLeft + '%';
              temp.querySelector('.handle').style.left = percentLeft + '%';
            }
          });

          handleLeft = percentLeft;

        }

        function getPercentage(value) {
          return (value - sliderMinValue) / (sliderMaxValue - sliderMinValue) * 100;
        }

        function getValueByPercentage(percent) {
          return sliderMinValue + ((sliderMaxValue - sliderMinValue) * percent / 100);
        }

        if (calculator.classList.contains('old-calculator')) {
          setInputValue_old(sliderValue);
          setSliderValue_old(sliderValue);
          setLabelValue_old(sliderValue);
        } else {
          setInputValue(sliderValue);
          setSliderValue(sliderValue);
          setLabelValue(sliderValue);
        }

        var dragging = false, startX = 0, startLeft, percentLeft;

        var startHandler = function(event) {
              dragging = true;
              startX = event.targetTouches ? event.targetTouches[0].clientX : event.clientX;
              sliderWidth = slider.offsetWidth;
              startLeft = handleLeft;
              startSliderValue = sliderValue;
            },
            moveHandler = function (event) {
              if(dragging) {
                var left =  (event.targetTouches ? event.targetTouches[0].clientX : event.clientX) - startX;
                sliderValue = startSliderValue + Math.round(( left / sliderWidth * (sliderMaxValue - sliderMinValue)));

                let outputValue = 0;
                if(sliderValue >= sliderMinValue && sliderValue <= sliderMaxValue) {
                  sliderValue = Math.round(sliderValue/steps) * steps;
                  outputValue = sliderValue;
                }
                else if (sliderValue >= sliderMaxValue) {
                  outputValue = sliderMaxValue;
                }
                else if (sliderValue <= sliderMinValue) {
                  outputValue = sliderMinValue;
                }

                if (calculator.classList.contains('old-calculator')) {
                  setInputValue_old(outputValue);
                  setSliderValue_old(outputValue);
                  setLabelValue_old(outputValue);
                } else {
                  setInputValue(outputValue);
                  setSliderValue(outputValue);
                  setLabelValue(outputValue);
                }
              }
            },
            endHandler = function(event) {
              dragging = false;
            }

        handle.addEventListener('mousedown', startHandler);
        handle.addEventListener('touchstart', startHandler);

        document.addEventListener('mousemove', moveHandler);
        document.addEventListener('touchmove', moveHandler);

        document.addEventListener('mouseup', endHandler)
        document.addEventListener('touchend', endHandler)
      });
    },

    zip: function (calculator) {
      var _self = this;
      var zips = calculator.querySelectorAll('input.zip');

      var streets = calculator.querySelectorAll('.street-field');
      var houseNumbers = calculator.querySelectorAll('.housenumber-field');

      [].forEach.call(streets, function(street) {
        street.style.display = 'none';
      });
      [].forEach.call(houseNumbers, function(street) {
        street.style.display = 'none';
      });

      var updateZip = function(zip, response) {
        var select = zip.parentNode.querySelector('select.city');

        var oldOptions = select.querySelectorAll('option');
        [].forEach.call(oldOptions, function (option, index) {
          if(index != 0) {
            select.removeChild(option);
          }
        });

        if(response.length != 0) {

          for(var key in response) {
            var option = document.createElement('option');
            option.setAttribute('value', response[key]);
            option.innerText = response[key];
            if(key == 0) {
              var tariffType, value;
              var container = zip.parentNode.parentNode.parentNode.parentNode.parentNode;
              var segment = calculator.getAttribute('data-segment');

              if (!container.parentNode.classList.contains('multi-step-form')) {
                if (segment == 'gas') {
                  tariffType = 0;
                  var temp = container.querySelector('.slider-input-gas');
                  if (temp) {
                    value = parseInt(temp.value)
                  }
                }

                if (segment == 'electricity') {
                  tariffType = 1;
                  var temp = container.querySelector('.slider-input-electricity');
                  if (temp) {
                    value = parseInt(temp.value)
                  }
                }

                if (segment == 'electricity-heizstrom') {
                  tariffType = 1;
                  var temp = container.querySelector('.slider-input-electricity-heizstrom');
                  if (temp) {
                    value = parseInt(temp.value)
                  }
                }

                var containerEmboil = container.querySelector('.form-type-select');
                if (containerEmboil && containerEmboil.classList.contains('emobility-combi-tariff')) {
                  tariffType = 1;
                  var temp = container.querySelector('.slider-input-emobility-combi-tariff-household');
                  if (temp) {
                    value = parseInt(temp.value);
                  }
                  var temp = container.querySelector('.slider-input-emobility-combi-tariff-mileage');
                  if (temp) {
                    value += parseInt(temp.value);
                  }
                }

                if (containerEmboil && containerEmboil.classList.contains('emobility-single-tariff')) {
                  tariffType = 2;
                  var temp = container.querySelector('.slider-input-emobility-single-tariff-mileage');
                  if (temp) {
                    value = parseInt(temp.value)
                  }
                }
              }

              option.setAttribute('selected', 1);
              if(value) {
                _self.street(zip.value, response[key], value, tariffType, calculator);
              }
            }
            select.appendChild(option);

          }

          select.addEventListener('change', function(event) {
            _self.street(zip.value, select.value, value, tariffType, calculator);
          })

        }

        if(response.length > 1) {
          select.removeAttribute('disabled');
        }
        else {
          select.setAttribute('disabled', 1);
        }
        _self.street(zip.value, select.value, value, tariffType, calculator);
      }

      var callAPI = function() {

        var zip = this;
        if(zip.value.length < 5 || ! calculator.classList.contains('active')) return;
        if (zip.hasAttribute('data-last') && zip.value.replace(/\s/g, '') == zip.getAttribute('data-last').replace(/\s/g, '')) return;
        zip.setAttribute('data-last', zip.value.replace(/\s/g, ''));

        let temp = document.querySelectorAll('.street-field [data-zip]');
        [].forEach.call(temp, function(temp2) {
          if (!temp2.hasAttribute('data-zipcurrent') || zip.value != temp2.getAttribute('data-zipcurrent')) {
            temp2.setAttribute('data-zipcurrent', zip.value);
            temp2.setAttribute('data-zip', null);
          }
        });

        [].forEach.call(document.querySelectorAll('input.zip'), (z) => {
          if(z != zip) {
            z.value = zip.value;
          }
        });

        if(calculatorBox.isLocal()) {
          // use local data for development
          var response = require('./city.json');
          var tempZip = document.querySelectorAll('.calc-fields .zip');
          [].forEach.call(tempZip, function(zip) {
            updateZip(zip, response);
          });
        } else {
          jQuery.ajax('/?id=3&type=30&tx_montanaorder_calculator[call]=cities&tx_montanaorder_calculator[params][zip]='+ this.value +'&no_cache=1',{
            method: 'GET',
            withCredentials: true,
            data: {
              zip: zip.value
            },
            dataType: 'json',
            success: function (response) {
              var tempZip = document.querySelectorAll('.calc-fields .zip');
              [].forEach.call(tempZip, function(zip) {
                updateZip(zip, response);
              });
            }
          });
        }
      };



      [].forEach.call(zips, function(zip) {
        //zip.addEventListener('blur', callAPI)
        zip.addEventListener('keyup', callAPI)
      })
    },

    street: function (zip, city, consumption, tariffType, calculator) {
      var streetFields = document.querySelectorAll('.street-field');

      // Reset street fields before getting populated with new data
      var resetStreet = function(streetField) {
        var select = streetField.querySelector('select.street');
        var housenumberTemp = streetField.parentNode.querySelector('.housenumber-field');
        streetField.style.display = 'none';
        if (housenumberTemp) {
          housenumberTemp.style.display = 'none';
        }

        if(select) {
          var oldOptions = select.querySelectorAll('option');
          [].forEach.call(oldOptions, function (option, index) {
            select.removeChild(option);
          });

          select.addEventListener('change', function(event) {
            // Update street data across all tabs in the calculator
            var selects = calculator.querySelectorAll('select.street');
            [].forEach.call(selects, function (s) {
              if(select != s) {
                s.value = select.value;
              }
            })
          });
        }
      }

      // Populate street fields with new data
      var updateStreet = function(streetField, response) {
        var select = streetField.querySelector('select.street');

        const changedData = (select && select.getAttribute('data-zip') != zip + '-' + city) ? true: false;

        if (select) {
          select.setAttribute('data-zip', zip + '-' + city)
        }

        if(typeof response.required_option == 'undefined') return;


        if (streetField.classList.contains('old-street-field')) {
          streetField.style.display = 'block';
        } else {
          streetField.style.display = 'flex';
        }
        var housenumber = streetField.parentNode.querySelector('.housenumber-field');
        if (housenumber) {
          if (streetField.classList.contains('old-street-field')) {
            housenumber.style.display = 'block';
          } else {
            housenumber.style.display = 'flex';
          }
        }

        if(select && changedData) {
          var oldOptions = select.querySelectorAll('option');
          [].forEach.call(oldOptions, function (option, index) {
            select.removeChild(option);
          })

          let optionsCount = 0;
          if(response.length != 0 && response.required_option.values) {
            for(var key in response.required_option.values) {

              var option = document.createElement('option');
              option.setAttribute('value', key);
              option.innerText = response.required_option.values[key];
              if(key == 0) option.setAttribute('selected', 1);
              select.appendChild(option);
              optionsCount++;
            }
          }

          if(response.required_option.values) {
            if (optionsCount > 0) {
              select.setAttribute('data-zip', zip + '-' + city);
            }
            select.removeAttribute('disabled');
          }
          else {
            select.setAttribute('disabled', 1);
          }
        }
      };

      var callAPI = function() {
        if(zip.length < 5) return;

        if(calculatorBox.isLocal()) {
          // use local data for development
          var response = require('./streets.json');
          [].forEach.call(streetFields, function(streetField) {
            updateStreet(streetField, response);
          });
        } else {
          jQuery.ajax('/?id=3&type=30&tx_montanaorder_calculator[call]=operatorCode' +
              '&tx_montanaorder_calculator[params][zip]='+ zip +
              '&tx_montanaorder_calculator[params][city]='+ city +
              '&tx_montanaorder_calculator[params][consumption]='+ consumption +
              '&tx_montanaorder_calculator[params][tariff_type]='+ tariffType +
              '&no_cache=1',{
            method: 'GET',
            withCredentials: true,
            data: {
              zip: zip
            },
            dataType: 'json',
            success: function (response) {
              // update fields
              [].forEach.call(streetFields, function(streetField) {
                updateStreet(streetField, response);
              });
            }
          });
        }
      };

      [].forEach.call(streetFields, function(streetField) {
        resetStreet(streetField);
      });

      callAPI();
    },

    submit: function (calculator) {
      // Exclude buttons that are used for navigation between tabs
      var buttons = calculator.querySelectorAll('.calc-content button:not([data-segment])'),
          getArea = function () {
            if(window.location.href.indexOf('privatkunden') != -1)
              return 'privatkunden';
            if(window.location.href.indexOf('geschaeftskunden') != -1)
              return 'geschaeftskunden';
            if(window.location.href.indexOf('immobilienwirtschaft') != -1)
              return 'immobilienwirtschaft';


            return 'privatkunden';
          };

      [].forEach.call(buttons, function (button) {
        if (! button.getAttribute('@click.prevent')) {
          button.addEventListener('click', function (e) {
            e.preventDefault();

            // Return if there is no zip code provided.
            if (this.parentNode.querySelector('.zip') && !this.parentNode.querySelector('.zip').value) {
              this.parentNode.querySelector('.zip').focus();
              return;
            }
            // validation of zip

            let zipElement = this.parentNode.querySelector('.zip');
            if (zipElement.value.toString().length != 5) {
              zipElement.parentNode.querySelector('.error_message_zip').style.display = 'block';
              if (this.parentNode.parentNode.classList.contains('old-calculator') && !zipElement.parentNode.classList.contains('zip-error')) {
                zipElement.parentNode.classList.add('zip-error')
              }
              this.parentNode.querySelector('.zip').focus();
              return;
            }

            let housenumberSection = this.parentNode.querySelector('.housenumber-field');
            if (housenumberSection) {
              housenumberSection.classList.remove('error-housenumber');
              if (housenumberSection.style.display === 'block' || housenumberSection.style.display === 'flex') {
                let housenumber = this.parentNode.querySelector('.housenumber');
                if (housenumber.value.toString().length == 0) {
                  housenumberSection.classList.add('error-housenumber');
                  return;
                }
              }
            }

            if (!submitEnabled) {
              return;
            }

            /**
             * Compose url from calculator input.
             * @param {element} parent
             */
            const buildUrl = function (parent) {
              // Mapping between energy type ID and text
              const consumptionType = {
                "0": "gas",
                "1": "strom",
                "2": "strom"
              };

              // Mapping between usage application (different to text above) and energy type ID
              const propertyMapping = {
                "gas": "0",
                "electricity": "1",
                "electricity-heizstrom": "2",
                "emobility-combi-tariff": "1",
                "emobility-single-tariff": "2",
                "emobility-combi-tariff-household": "2",
                "emobility-combi-tariff-mileage": "1",
                "emobility-single-tariff-mileage": "2",
              }

              // Additional parameters that are appended if the segment is active
              const specialParameters = {
                "electricity-heizstrom": "&heating_type=pump",
                "emobility-combi-tariff": "&kombi_radio=kombi",
                "emobility-single-tariff": "&heating_type=night_storage"
              }

              const alternativeTel = (calculator.querySelector('.alternative_tel')) ? calculator.querySelector('.alternative_tel').value : '',
                  zip = parent.querySelector('.zip').value,
                  city = parent.querySelector('.city').value,
                  housenumberCustom = (parent.querySelector('.housenumber')) ? parent.querySelector('.housenumber').value : false,
                  street = parent.querySelector('.street') ? parent.querySelector('.street').value : null,
                  checkbox = parent.querySelector('input[data-verify]'),
                  area = getArea(),
                  target = parent.querySelector('.target') && parent.querySelector('.target').value ? parent.querySelector('.target').value : 'tarifergebnis',
                  customerType = area == 'privatkunden' ? 0 : 1;
              var baseURL = 'https://bestellung.montana-energie.de/privatkunden/' + target + '/?formBlockID=611';
              var devhosts = ['localhost', 'test-hp.montana-energie.de'];
              if (devhosts.indexOf(window.location.hostname) > -1) {
                baseURL = 'https://einsnull:joulesweb@montana-web-de-staging.joules.app/privatkunden/' + target + '/?formBlockID=611';
              }

              let houseNumber = 1;
              if (zip == '80335' && street && street == 'Arnulfstr.') {
                houseNumber = 2;
              }
              if (housenumberCustom && housenumberCustom.length > 0) {
                function getFirstNumber(input) {
                  const match = input.match(/\d+/);  // This matches the first sequence of digits
                  return match ? match[0] : 1;    // Return the first match or null if no match is found
                }

                houseNumber = getFirstNumber(housenumberCustom).toString().substring(0, 4)
              }


              let url = baseURL
              // if checkbox is checked, energy type of checkbox overwrites that of the segment
              // use id of input fields for slider
              url += '&energy_type=' + (checkbox && checkbox.checked ? checkbox.dataset.energyType : propertyMapping[parent.dataset.segment]);
              url += (checkbox && checkbox.checked ? checkbox.dataset.verify : '');
              url += '&TK-zip=' + zip;
              url += '&TK-city=' + encodeURIComponent(city);
              url += '&customer_type=' + customerType;
              url += ((street) ? '&TK-Street=' + encodeURIComponent(street) + '&query_house_number=' + encodeURIComponent(houseNumber) : '');
              // url += ((street) ? '&TK-Street=' + encodeURIComponent(street) : '');
              url += (alternativeTel ? '&Tel994=1' : '');
              // Append special parameters
              url += specialParameters[parent.dataset.segment] ? specialParameters[parent.dataset.segment] : ''


              const consumptionMap = new Map();
              // For each type that occurs, sum up the values of all sliders associated with that type
              [].forEach.call(parent.querySelectorAll('input[data-id*="slider-input"]'), function (_slider) {
                const _type = consumptionType[propertyMapping[_slider.getAttribute('data-id').replace('slider-input-', '')]];

                if (consumptionMap.has(_type)) {
                  // Sum up values of equal type
                  consumptionMap.set(_type, consumptionMap.get(_type) + parseInt(_slider.value));
                } else {
                  consumptionMap.set(_type, parseInt(_slider.value));
                }
              });

              // Add every consumption type there is and append it to the url
              consumptionMap.forEach(function (val, key) {
                url += '&consumption_' + key + '=' + parseInt(val);
              });


              // Special attribute for ADAC customers
              if (document.body.id == 2029) {
                url = url.replace('formBlockID=611', 'formBlockID=55799');
                url = url.replace('/tarifergebnis/', '/adac/')
                url += "&cooperation=adac";
              }
              return url;
            }

            /**
             * Validate inputs of the calculator.
             */
            const isValid = function (parent) {
              const requiredFields = parent.querySelectorAll('[required]');
              let valid = true;

              [].forEach.call(requiredFields, function (field) {
                if (!field.checkValidity()) {
                  valid = field.checkValidity();
                  field.reportValidity();
                }
              });
              return valid;
            }

            let url = '';
            if (this.parentNode.classList.contains('oil')) {
              // collect data
              var type = 0,
                  zip = this.parentNode.querySelector('.zip').value,
                  city = this.parentNode.querySelector('.city').value,
                  value = parseInt(this.parentNode.querySelector('.slider-input').value),
                  storage = this.parentNode.querySelector('.storage').value;
              url = '/privatkunden/heizoel/heizoel-bestellstrecke/?fe_plz=' + zip + '&fe_liefermenge=' + value + '&fe_abladestellen=' + storage + '&fe_sent=1';
            } else {
              url = buildUrl(this.parentNode);
            }

            if (isValid(this.parentNode)) {
              var currentArea = getArea();
              var segment = this.parentNode.getAttribute('data-segment');
              var customType = 'Private';
              var customSegment = 'Storm';
              var value = 0;

              switch (currentArea) {
                case 'geschaeftskunden':
                  customType = 'Business'
                  break;
                case 'immobilienwirtschaft':
                  customType = 'Real Estate'
                  break;
              }

              switch (segment) {
                case 'oil':
                  customSegment = 'Heizöl';
                  value = calculator.querySelector('.slider-input').value;
                  break;
                case 'gas':
                  customSegment = 'Erdgas';
                  value = calculator.querySelector('.slider-input-gas').value;
                  break;
                case 'emobility':
                  customSegment = 'Autostrom';
                  value = 0;
                  break;
                case 'emobility-single-tariff':
                  customSegment = 'Autostrom';
                  value = calculator.querySelector('.slider-input-emobility-single-tariff-mileage').value;
                  break;
                case 'emobility-combi-tariff':
                  var value1 = calculator.querySelector('.slider-input-emobility-combi-tariff-household').value;
                  var value2 = calculator.querySelector('.slider-input-emobility-combi-tariff-mileage').value;

                  customSegment = 'Autostrom';
                  value = parseInt(value1) + parseInt(value2);
                  break;
                case 'electricity-heizstrom':
                  customSegment = 'Heizstrom';
                  value = calculator.querySelector('.slider-input-electricity-heizstrom').value;
                  break;
                case 'electricity':
                  customSegment = 'Ökostrom';
                  value = calculator.querySelector('.slider-input-electricity').value;
                  break;
              }

              value = parseInt(value);

              window.dataLayer = window.dataLayer || [];
              let eventName = 'tarifrechner';

              var tempEventName = calculator.querySelector('.form-type');
              if (tempEventName && tempEventName.value && tempEventName.value.length > 0 && tempEventName.value != '_modal') {
                eventName = 'tarifrechner_' + tempEventName.value;
              }

              window.dataLayer.push({
                'event': eventName,
                'energyType': customSegment, // Ökostrom, Wärmestrom, Autostrom oder Gas
                'consumption': value, // kWh pro Jahr
                'customerType': customType
              });
              if (submitEnabled) {
                submitEnabled = false;
                window.open(url, '_self');
                setTimeout(() => {submitEnabled = true}, 500);
              }
            }
          });
        }
      });
    },

    /**
     * Sets custom validation message for inputs with data-custom-validity attribute.
     * @param {*} calculator container.
     */
    customValidity: function (calculator) {
      var inputs = calculator.querySelectorAll('input[data-custom-validity]');

      var setValidityMessage = function(_input) {
        if(_input.validity.valueMissing) {
          // if checkbox is unchecked, display validation message
          _input.setCustomValidity(_input.dataset.customValidity);
        } else {
          _input.setCustomValidity('');
        }
      };

      [].forEach.call(inputs, function(input) {
        setValidityMessage(input);
        input.addEventListener('change', function() {
          setValidityMessage(input);
        });
      });
    }
  }

  // Initialize script for each calculator
  var submitEnabled = true;
  var calculators = document.querySelectorAll('.calculator-box, .calc-content');
  [].forEach.call(calculators, function(calculator){
    calculatorBox.init(calculator);
  });

  document.addEventListener('DOMContentLoaded', function() {
    // Select all anchor tags
    const allLinks = document.querySelectorAll('a');

    allLinks.forEach(link => {
      // Parse the link's href
      const url = new URL(link.href, window.location.origin);

      // Check if the link points to the same page and has a 'kalkulator' parameter
      if (url.pathname === window.location.pathname && url.searchParams.has('kalkulator')) {
        link.addEventListener('click', function(event) {
          // Extract the 'kalkulator' parameter
          let kalkulatorValue = url.searchParams.get('kalkulator');
          if (kalkulatorValue) {
            if (kalkulatorValue == 'heating') { kalkulatorValue = 'electricity-heizstrom'}
            const formButton = document.querySelector('.footer-calculator .form-type-select .form-select-button.'+kalkulatorValue);
            if (formButton) {
              event.preventDefault();
              formButton.click();
            }
          }
        });
      }
    });
  });

})();
